<template>
  <div class="job-results">
    <div class="result-item-wrapper" v-for="(job, index) in jobs" :key="index">
      <div
        class="result-item mobile-view"
        v-touch:swipe.left="() => onSwipeLeft(job, index)"
        v-touch:swipe.right="() => onSwipeRight(job, index)"
        :class="{ swipedLeft: showActions[index] }"
      >
        <div class="job-info">
          <div class="job-image-title" @click="showDetail(job.id)">
            <div
              class="image_wrapper"
              data-testid="directions-64"
              @click="userInfoModalOpen(job.jobPharmacy)"
            >
              <el-avatar
                :size="'small'"
                shape="square"
                :src="job.image"
                v-if="job.image"
              />
              <el-avatar
                :size="'small'"
                class="avatar-job"
                shape="square"
                icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                v-else
              ></el-avatar>
            </div>
            <div class="job-detail-main">
              <div class="job-title">{{ job.title }}</div>
              <div class="job-poster">{{ job.poster }}</div>
            </div>
          </div>
          <div class="job-option-links">
            <el-tooltip
              :content="
                job.favorite ? 'Remove from favorite' : 'Mark as favorite'
              "
              placement="top"
            >
              <div
                class="favorite"
                :class="{ selected: job.favorite }"
                @click="markFavorite(job)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#B3B6BE"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0166 1.6665H5.98327C4.20827 1.6665 2.7666 3.1165 2.7666 4.88317V16.6248C2.7666 18.1248 3.8416 18.7582 5.15827 18.0332L9.22493 15.7748C9.65827 15.5332 10.3583 15.5332 10.7833 15.7748L14.8499 18.0332C16.1666 18.7665 17.2416 18.1332 17.2416 16.6248V4.88317C17.2333 3.1165 15.7916 1.6665 14.0166 1.6665ZM12.0833 9.49984H7.9166C7.57494 9.49984 7.2916 9.2165 7.2916 8.87484C7.2916 8.53317 7.57494 8.24984 7.9166 8.24984H12.0833C12.4249 8.24984 12.7083 8.53317 12.7083 8.87484C12.7083 9.2165 12.4249 9.49984 12.0833 9.49984Z"
                    fill="#B3B6BE"
                  />
                </svg>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="job-detail-more" @click="showDetail(job.id)">
          <el-tag class="inverted">
            {{ job.type }}
          </el-tag>
          <el-tag class="inverted">
            {{ job.payInterval }} Rate: <strong>{{ job.payRate }}</strong>
          </el-tag>
          <el-tag class="inverted" v-if="job.federalPharmacistSupport && isUS">
           <span v-if="job.federalPharmacistSupport === 1">Federal Pharmacist Support</span>
          </el-tag>
          <el-tag class="inverted"> Published {{ job.published }} </el-tag>
        </div>
        <div class="job-detail-row-item" @click="showDetail(job.id)">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
            />
            <path
              d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
            />
          </svg>
          <div class="job-detail-text">
            {{ job.location }}
          </div>
        </div>
        <div class="job-detail-row-item" @click="showDetail(job.id)" v-if="job?.jobPharmacy?.software">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.66675 4.99984V4.33317C6.66675 2.85817 6.66675 1.6665 9.33341 1.6665H10.6667C13.3334 1.6665 13.3334 2.85817 13.3334 4.33317V4.99984"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.0417 9.1665C16.1167 10.5665 13.9167 11.3998 11.6667 11.6832"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="job-detail-text">
            {{ job.jobPharmacy.software
            }}<span v-if="job.jobPharmacy.software === 'Other'"
              >: {{ job.jobPharmacy.softwareOther }}</span
            >
          </div>
        </div>
        <div class="job-detail-row-item" v-if="job.expiryDate">
          <ClockIcon />
          <div class="job-detail-text">
            {{ formatExpiryDate(job.expiryDate) }}
          </div>
        </div>
      </div>

      <div
        class="result-item desktop-view"
        v-touch:swipe.left="() => onSwipeLeft(job, index)"
        v-touch:swipe.right="() => onSwipeRight(job, index)"
        :class="{ swipedLeft: showActions[index] }"
      >
        <div class="job-info">
          <div class="job-image-title">
            <div
              class="image_wrapper"
              data-testid="directions-64"
              @click="userInfoModalOpen(job.jobPharmacy)"
            >
              <el-avatar
                :size="'small'"
                shape="square"
                :src="job.image"
                v-if="job.image"
              />
              <el-avatar
                :size="'small'"
                class="avatar-job"
                shape="square"
                icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                v-else
              ></el-avatar>
            </div>
            <div class="job-detail-main">
              <div class="job-title">{{ job.title }}</div>
              <div class="job-poster">{{ job.poster }}</div>
            </div>
          </div>
          <div class="job-option-links">
            <el-tooltip
              :content="
                job.favorite ? 'Remove from favorite' : 'Mark as favorite'
              "
              placement="top"
            >
              <div
                class="favorite"
                :class="{ selected: job.favorite }"
                @click="markFavorite(job)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#B3B6BE"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0166 1.6665H5.98327C4.20827 1.6665 2.7666 3.1165 2.7666 4.88317V16.6248C2.7666 18.1248 3.8416 18.7582 5.15827 18.0332L9.22493 15.7748C9.65827 15.5332 10.3583 15.5332 10.7833 15.7748L14.8499 18.0332C16.1666 18.7665 17.2416 18.1332 17.2416 16.6248V4.88317C17.2333 3.1165 15.7916 1.6665 14.0166 1.6665ZM12.0833 9.49984H7.9166C7.57494 9.49984 7.2916 9.2165 7.2916 8.87484C7.2916 8.53317 7.57494 8.24984 7.9166 8.24984H12.0833C12.4249 8.24984 12.7083 8.53317 12.7083 8.87484C12.7083 9.2165 12.4249 9.49984 12.0833 9.49984Z"
                    fill="#B3B6BE"
                  />
                </svg>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="job-detail-more">
          <el-tag class="inverted">
            {{ job.type }}
          </el-tag>
          <el-tag class="inverted" v-if="!job.hideSalary">
            {{ job.payInterval }} Rate: <strong>{{ job.payRate }}</strong>
          </el-tag>
          <el-tag class="inverted" v-if="job.federalPharmacistSupport && isUS">
           <span v-if="job.federalPharmacistSupport === 1">
            
            Federal Pharmacist Support
          </span>
          </el-tag>
          <el-tag class="inverted"> Published {{ job.published }} </el-tag>
        </div>
        <div class="job-detail-row-item">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
            />
            <path
              d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
            />
          </svg>
          <div class="job-detail-text">
            {{ job.location }}
          </div>
        </div>
        <div class="job-detail-row-item" v-if="job?.jobPharmacy?.software">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M6.66675 4.99984V4.33317C6.66675 2.85817 6.66675 1.6665 9.33341 1.6665H10.6667C13.3334 1.6665 13.3334 2.85817 13.3334 4.33317V4.99984"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.0417 9.1665C16.1167 10.5665 13.9167 11.3998 11.6667 11.6832"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916"
              stroke="rgb(var(--locumate-primary-color))"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="job-detail-text">
            {{ job.jobPharmacy.software
            }}<span v-if="job.jobPharmacy.software === 'Other'"
              >: {{ job.jobPharmacy.softwareOther }}</span
            >
          </div>
        </div>
        <div class="job-detail-row-item" v-if="job.expiryDate">
          <ClockIcon />
          <div class="job-detail-text">
            {{ formatExpiryDate(job.expiryDate) }}
          </div>
        </div>
        <el-button class="text-only desktop-view" @click="showDetail(job.id)">
          View Details
        </el-button>
      </div>
      <div class="actions" v-show="showActions[index]"></div>
      <button
        @click="removeJob(job.id)"
        class="delete-btn"
        v-show="showActions[index]"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
            fill="white"
          />
          <path
            d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
  <modal-user-info
    :modalName="'userInfoModal'"
    :options="userInfoModal"
  ></modal-user-info>

  <!-- <el-dialog title="Add wishlist" :class="wishlist - dialog" v-model="modalVisible" width="50%"
    :close-on-click-modal="true" @close="closeWishlistModal">
    <div class="grid-container" v-if="wishLists.length > 0">
      <div class="grid-item" v-for="(item, index) in wishLists" :key="index" @click="toggleHeart(index, item)">

        <div class="initial-avatar" :style="{ backgroundColor: getRandomColor(item.title) }">
          {{ item.title.substring(0, 1).toUpperCase() }}
        </div>
        <div class="grid-title">{{ item.title }}</div>
        <div class="grid-saved">{{ item.saved }} saved</div>
        <div class="favorite rounded-action selected" v-if="showHeart[index]">
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.1527 2.25684C2.81629 1.53356 3.69496 1.09244 4.63041 1.01298C5.56587 0.933509 6.4966 1.22091 7.25492 1.8234C8.05603 1.19143 9.0459 0.911269 10.0278 1.03859C11.0097 1.16592 11.9116 1.69141 12.5545 2.51061C13.1973 3.32982 13.5339 4.38276 13.4973 5.46015C13.4607 6.53753 13.0537 7.56048 12.3571 8.32565L8.64625 12.3718C8.27721 12.774 7.77675 13 7.25492 13C6.73309 13 6.23263 12.774 5.86358 12.3718L2.1527 8.32636C1.41464 7.52157 1 6.43007 1 5.29196C1 4.15385 1.41464 3.06163 2.1527 2.25684Z"
              stroke="#8790A6" />
          </svg>
        </div>
      </div>
    </div>
    <div v-else class="empty-wishlist">Create your first wishlist.</div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="closeWishlistModal">Skip adding to wishlist</el-button>
      <el-button type="primary" @click="createNewWishlist">Create new wishlist</el-button>
    </div>
  </el-dialog> -->

  <el-drawer
    title="Add wishlist"
    custom-class="add-wishlist"
    v-model="modalVisible"
    :append-to-body="true"
    :direction="'btt'"
    :destroy-on-close="true"
    @close="closeWishlistModal"
  >
    <div class="grid-container" v-if="wishLists.length > 0">
      <div
        class="grid-item"
        v-for="(item, index) in wishLists"
        :key="index"
        @click="toggleHeart(index, item)"
        :style="{ borderColor: getRandomColor(item.title) }"
      >
        <div
          class="initial-avatar"
          :style="{ backgroundColor: getRandomColor(item.title) }"
        >
          {{ item.title.substring(0, 1).toUpperCase() }}
        </div>
        <div class="item-detail">
          <div class="grid-title">{{ item.title }}</div>
          <div class="grid-saved">{{ item.saved }} saved</div>
          <!-- <div class="favorite rounded-action selected" v-if="showHeart[index]"> -->
        </div>
        <div class="favorite rounded-action selected" v-if="showHeart[index]">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#FFB800"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.0166 1.6665H5.98327C4.20827 1.6665 2.7666 3.1165 2.7666 4.88317V16.6248C2.7666 18.1248 3.8416 18.7582 5.15827 18.0332L9.22493 15.7748C9.65827 15.5332 10.3583 15.5332 10.7833 15.7748L14.8499 18.0332C16.1666 18.7665 17.2416 18.1332 17.2416 16.6248V4.88317C17.2333 3.1165 15.7916 1.6665 14.0166 1.6665ZM12.0833 9.49984H7.9166C7.57494 9.49984 7.2916 9.2165 7.2916 8.87484C7.2916 8.53317 7.57494 8.24984 7.9166 8.24984H12.0833C12.4249 8.24984 12.7083 8.53317 12.7083 8.87484C12.7083 9.2165 12.4249 9.49984 12.0833 9.49984Z"
              fill="#FFB800"
            />
          </svg>
        </div>
      </div>
    </div>
    <div v-else class="empty-wishlist">Create your first wishlist</div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="createNewWishlist"
        >Create a new wishlist</el-button
      >
      <el-button class="secondary" @click="closeWishlistModal"
        >Skip adding to wishlist</el-button
      >
    </div>
  </el-drawer>

  <el-drawer
    title="Create wishlist"
    custom-class="add-wishlist"
    v-model="modalCreateVisible"
    :close-on-click-modal="true"
    :destroy-on-close="true"
    @close="closeCreateWishlistModal"
    :append-to-body="true"
    :direction="'btt'"
  >
    <el-form :model="form">
      <el-form-item
        :error="v$.title.$error"
        :show-message="false"
        class="no-scroll"
        label="Wishlist Name"
        :required="true"
        prop="title"
      >
        <el-input
          :maxlength="50"
          v-model="form.title"
          placeholder="Enter wishlist name"
          @input="validateField('title')"
        ></el-input>
        <span class="character-count" v-if="form.title.length < 50"
          >{{ form.title.length }}/50 characters</span
        >
        <el-form-item-error v-if="v$.title.$error">{{
          v$.title.$errors[0].$message
        }}</el-form-item-error>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer create-wl-footer add-wishlist">
      <el-button
        type="primary"
        @click="addToWishlist"
        :disabled="isSubmitDisabled"
        >Create</el-button
      >
      <el-button class="secondary" @click="clearInput">Clear</el-button>
    </span>
  </el-drawer>
</template>

<script>
import { inject, ref, reactive, computed, onBeforeMount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { PharmacyInfoModal } from "@/modals/modals";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, helpers } from "@vuelidate/validators";
import { vTouch } from "vue3-touch-events";
import { formatExpiryDate } from '@/helpers/utility/utility.js';
import ClockIcon from '@/components/Icons/ClockIcon.vue';
import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { trackEvent } from '@/helpers/analytics/ga.js';

export default {
  props: {
    jobs: {
      type: Array,
      required: true,
    },
  },
  components: {
    "modal-user-info": PharmacyInfoModal,
    ClockIcon,
  },

  setup(props, { emit }) {
    const $store = useStore();
    console.log("🚀 ~ setup ~ props:", props);
    const $router = useRouter();
    const $modals = inject("$modals");
    const userData = $store.getters.GET_USER_DATA;
    const modalVisible = ref(false);
    const modalCreateVisible = ref(false);
    const showHeart = ref([]);
    const selectedJobID = ref(null);
    const isUS = isUSRegion();

    const showActions = ref([]);
    // const userRole = userData.role;
    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const wishLists = ref([
      { title: "Los Angeles short stay", saved: 2 },
      { title: "2023 Oct Los Angeles, CA, United States", saved: 0 },
      { title: "morn", saved: 1 },
      { title: "Waterloo", saved: 0 },
    ]);

    const form = reactive({
      title: "",
    });

    // Vuelidate setup

    const rules = computed(() => {
      return {
        title: {
          required: helpers.withMessage(
            "Please enter the wishlist name",
            required
          ),
          maxLength: maxLength(50),
        },
      };
    });
    const v$ = useVuelidate(rules, form);

    const validateField = (fieldName) => {
      // Trigger validation for the specified field
      v$.value[fieldName].$touch();
    };
    const addToWishlist = async () => {
      const result = await v$.value.$validate();

      if (!result) {
        alert("The form has errors");
        return;
      } else {
        const response = await $store.dispatch(
          "SAVE_SEEKER_WISHLIST_NAME",
          form
        );

        if (response.success) {
          ElMessage({
            type: "success",
            message: response.message,
          });
          wishLists.value = response.data;
          form.title = "";
          modalCreateVisible.value = false;
          v$.reset();
        } else {
          ElMessage({
            type: "error",
            message: response.message,
          });
        }
      }
    };
    const isSubmitDisabled = computed(() => {
      return (
        Object.values(form).some((value) => value === "") ||
        v$.value.$pending ||
        v$.value.$error
      );
    });

    function getRandomColor(title) {
      // Convert the title to a hash code
      let hash = 0;
      for (let i = 0; i < title.length; i++) {
        hash = title.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Generate color based on the hash
      let color = "#";
      for (let i = 0; i < 3; i++) {
        // Adjust the generated color to be within the light spectrum
        let value = (hash >> (i * 8)) & 0xff;
        // Ensure the value is in the range of light colors and not too close to white
        value = 180 + (value % 56); // 180 to 235 range
        color += ("00" + value.toString(16)).slice(-2);
      }

      // Ensure the color is not pure white
      if (color.toUpperCase() === "#FFFFFF") {
        return "#FAFAFA"; // Return a very light gray instead of white
      }

      return color;
    }

    const clearInput = () => {
      form.title = "";
    };
    const toggleHeart = async (index, item) => {
      showHeart.value[index] = true;
      await (async () => {
        try {
          const response = await $store.dispatch("ADD_WISHLIST_FAV", {
            jobId: selectedJobID.value,
            wishlistId: item.id,
          });
          emit("job-favorite", selectedJobID, response.data.data);
          if (response.data.success) {
            ElMessage({
              type: "success",
              message: response.data.message,
            });
            wishLists.value = response.data.data;
            modalVisible.value = false;
          } else {
            ElMessage({
              type: "error",
              message: response.data.message,
            });
          }
        } catch (error) {
          console.log(error);
        }
      })();

      setTimeout(() => {
        showHeart.value[index] = false;
      }, 1000); // Adjust duration as needed
    };
    const userInfoModalOpen = (user) => {
      if (user) {
        userInfoModal.value.user = user;
      }
      $modals.open("userInfoModal");
    };

    const showDetail = (jobId) => {
      const job = props.jobs.find(j => j.id === jobId);
      trackEvent('job_clicked', { job_id: jobId, job_title: job?.title, user_type: 'logged_in' });
      $router.push({
        name: "job_seeker_application_details",
        params: { jobId: jobId },
      });
    };

    const openWishlistModal = (job) => {
      console.log("🚀 ~ openWishlistModal ~ job:", job);
      // Show the modal
      modalVisible.value = true;
    };
    const closeWishlistModal = () => {
      modalVisible.value = false;
    };

    const createNewWishlist = () => {
      modalCreateVisible.value = true;
    };

    const closeCreateWishlistModal = () => {
      form.title = "";

      modalCreateVisible.value = false;
      v$.value["title"].$reset();
    };

    const goToMap = (pharmacy) => {
      // ${encodeURI('https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=transit')}
      // https://www.google.com/maps/search/?api=1&query=
      // window.open(`https://www.google.com/maps/place/${user.value.address.lat},${user.value.address.lng}`)

      if (
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("MacIntel") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      ) {
        const originCord = userData.address.lat + "," + userData.address.lng;

        const destinationCord =
          pharmacy.address.lat + "," + pharmacy.address.lng;

        const origin = userData.address ? `saddr=${originCord}&` : "";

        const destination = pharmacy.address ? `daddr=${destinationCord}&` : "";

        window.open(
          `http://maps.apple.com/?${origin}${destination}dirflg=d&t=m`
        );
      }

      // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`);
      // window.open(`http://maps.apple.com/?saddr=${userData.address.text}&daddr=${user.value.address.text}&dirflg=d&t=m`);
      else {
        const zoom = `&zoom=16`;
        const origin = userData.address.lat
          ? `&origin=${userData.address.lat},${userData.address.lng}`
          : "";
        const destination = pharmacy.address.lat
          ? `&destination=${pharmacy.address.lat},${pharmacy.address.lng}`
          : "";
        window.open(
          `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic${origin}${destination}${zoom}`
        );
      }
    };

    const goToChat = (pharmacy) => {
      const chatId = pharmacy.id + "." + userData.id;
      $router.push({
        name: "job_seeker_chat_message",
        params: {
          chatId: chatId,
        },
      });
    };

    const markFavorite = async (job) => {
      console.log("🚀 ~ markFavorite ~ job:", job);
      console.log("🚀 ~ wishLists.values:", wishLists.value);

      const belongsToWishLists = wishLists.value.some((wishlist) => {
        return Array.isArray(wishlist.jobs) && wishlist.jobs.length > 0
          ? wishlist.jobs.some((wishlistJob) => wishlistJob.id === job.id)
          : false;
      });
      console.log(
        "🚀 ~ belongsToWishLists ~ belongsToWishLists:",
        belongsToWishLists
      );
      const confirmMessage = job.favorite
        ? `Are you sure you want to remove this job from your favorite list? ${
            belongsToWishLists
              ? "<br><p style='color: #F56C6C;'>Please note that this will also remove the job from saved wishlist.</p></br>"
              : ""
          }`
        : "Are you sure you want to mark this job as favorite?";

      const confirmButtonText = job.favorite ? "Remove" : "Favorite";
      const confirmButtonTitle = job.favorite
        ? "Remove from favorite list"
        : "Favorite this job";
      const confirmButtonClass = job.favorite
        ? "el-button--danger"
        : "el-button--success";
      try {
        if (job.favorite) {
          await ElMessageBox.confirm(confirmMessage, confirmButtonTitle, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: "Cancel",
            confirmButtonClass: confirmButtonClass,
            cancelButtonClass: "secondary",
            showClose: false,
          });
        }

        await (async () => {
          try {
            const response = await $store.dispatch("TOGGLE_FAVORITE", {
              jobId: job.id,
            });
            emit("job-favorite", job.id, response.data.data);
            if (response.data.success) {
              ElMessage({
                type: "success",
                message: response.data.message,
              });
              if (job.favorite == true) {
                console.log("tttttttttttttttttttttttttt", job.favorite);
                selectedJobID.value = job.id;
                setTimeout(() => {
                  modalVisible.value = true;
                }, 800);
              }
              const newWishlistFetch = await $store.dispatch(
                "FETECH_SEEKER_WISHLIST"
              );
              wishLists.value = newWishlistFetch.data.data;
            } else {
              ElMessage({
                type: "error",
                message: response.data.message,
              });
            }
          } catch (error) {
            console.log(error);
          }
        })();
      } catch (error) {
        console.log(error);
      }
    };

    const removeJob = async (jobId) => {
      try {
        const belongsToWishLists = wishLists.value.some((wishlist) => {
          return wishlist.jobs.some((wishlistJob) => wishlistJob.id === jobId);
        });
        await ElMessageBox.confirm(
          `Are you sure you want to remove this job? ${
            belongsToWishLists
              ? "<br><p style='color: #F56C6C;'>Please note that this will also remove the job from saved wishlist.</p></br>"
              : ""
          }`,
          "Remove job",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Remove",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--danger",
            cancelButtonClass: "el-button--grey",
            showClose: false,
          }
        );

        await (async () => {
          try {
            const response = await $store.dispatch(
              "REMOVE_JOB_FROM_JOB_SEEKER_LIST",
              { jobId: jobId }
            );

            if (response.data.success) {
              emit("jobRemoved", jobId);
              ElMessage({
                type: "success",
                message: response.data.message,
              });
              showActions.value = Array(props.jobs.length).fill(false);
              const newWishlistFetch = await $store.dispatch(
                "FETECH_SEEKER_WISHLIST"
              );
              wishLists.value = newWishlistFetch.data.data;
            } else {
              ElMessage({
                type: "success",
                message: response.data.message,
              });
            }
          } catch (error) {
            console.log(error);
          }
        })();
      } catch (error) {
        console.log(error);
      }
    };

    onBeforeMount(async () => {
      try {
        const response = await $store.dispatch("FETECH_SEEKER_WISHLIST");

        wishLists.value = response.data.data;
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Hide the loading screen if an error occurs
      }
    });

    const onSwipeLeft = (job, index) => {
      console.log("🚀 ~ onSwipeLeft ~ job:", job);
      showActions.value[index] = true;
      // return function (direction, mouseEvent) {
      //   console.log("Swiped item ", index, ": ", job, " in direction ", direction);
      //   console.log("MouseEvent" , mouseEvent);

      // };
    };

    const onSwipeRight = (job, index) => {
      console.log("🚀 ~ onSwipeRight ~ job:", job);
      showActions.value[index] = false;
    };

    onMounted(() => {
      showActions.value = Array(props.jobs.length).fill(false);
      const touchEvents = vTouch({
        swipe: {
          threshold: 15, // Adjust the swipe threshold if needed
        },
      });
      touchEvents.install(); // Install the touch events
    });

    // const touchEvents = vTouch({
    //   swipe: {
    //     threshold: 15, // Adjust the swipe threshold if needed
    //   },
    // });
    // touchEvents.install();

    // useTouch();

    return {
      onSwipeLeft,
      onSwipeRight,
      showActions,
      userInfoModal,
      userInfoModalOpen,
      showDetail,
      removeJob,
      goToMap,
      goToChat,
      markFavorite,
      openWishlistModal,
      closeWishlistModal,
      modalVisible,
      modalCreateVisible,
      createNewWishlist,
      closeCreateWishlistModal,
      wishLists,
      getRandomColor,
      toggleHeart,
      showHeart,
      form,
      addToWishlist,
      v$,
      validateField,
      isSubmitDisabled,
      clearInput,
      selectedJobID,
      formatExpiryDate,
      isUS
    };
  },
};
</script>

<style scoped>
/* Component-specific styles go here */
/* span {
  cursor: pointer;
  color: red;
} */
</style>
